import "./shared/theme/global.css";
import React, { lazy, Suspense, useCallback, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { ThemeProvider } from "./shared/theme/ThemeContext";
import { ChatProvider } from "./features/chat/ChatContext";
import { useKonamiCode } from "./shared/hooks/useKonamiCode";
import Home from "./features/home/home";
import AllResults from "./features/results/allResults";
import CategoryResults from "./features/results/categoryResults";
import NotFound from "./features/not-found/notFound";

const GmailApp = lazy(() => import("./features/gmail/GmailApp"));
const WikipediaPage = lazy(() => import("./features/wikipedia/WikipediaPage"));
const ProjectsPage = lazy(() => import("./features/projects/ProjectsPage"));
const MapsPage = lazy(() => import("./features/maps/MapsPage"));
const DrivePage = lazy(() => import("./features/drive/DrivePage"));
const ResumePage = lazy(() => import("./features/resume/ResumePage"));
const GalleryPage = lazy(() => import("./features/gallery/GalleryPage"));
const ChatWidget = lazy(() => import("./features/chat/ChatWidget"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function KonamiHandler() {
  const onKonami = useCallback(() => {
    document.body.classList.add("konami-party");
    setTimeout(() => document.body.classList.remove("konami-party"), 3000);
  }, []);
  useKonamiCode(onKonami);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <ChatProvider>
        <Router>
          <ScrollToTop />
          <KonamiHandler />
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/all" element={<AllResults />} />
              <Route path="/email/*" element={<GmailApp />} />
              <Route path="/about" element={<WikipediaPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/maps" element={<MapsPage />} />
              <Route path="/drive" element={<DrivePage />} />
              <Route path="/resume" element={<ResumePage />} />
              <Route path="/photos" element={<GalleryPage />} />
              <Route path="/notfound" element={<NotFound />} />
              <Route path="/:category" element={<CategoryResults />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <ChatWidget />
          </Suspense>
        </Router>
      </ChatProvider>
    </ThemeProvider>
  );
}

export default App;
